import Proxies from 'Components/proxies'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { Button, Input } from 'reactstrap'
import Reflux from 'reflux'
import { toast } from 'react-toastify'
import nl2br from './nl2br'

const CommentSection = props => {
  const [comments, setComments] = useState([])
  const [newCommentMessage, setNewCommentMessage] = useState('')
  const userId = Reflux.GlobalState.LoginStore.user.UserID

  const handleKeyPress = e => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      onCommentCreate()
    }
  }

  const fetchComments = () => {
    Proxies.GET('comments/pool', { relatedType: props.relatedType, relatedID: props.relatedID }).then(responseJSON => {
      if (responseJSON && responseJSON.error) {
        toast.error('Fetching comments failed', {
          autoClose: 3000
        })
      } else {
        setComments(responseJSON)
      }
    })
  }

  const onCommentCreate = () => {
    const comment = {
      relatedType: props.relatedType,
      relatedID: props.relatedID,
      message: newCommentMessage
    }
    Proxies.POST('comments/createComment', comment).then(responseJSON => {
      if (responseJSON && responseJSON.error) {
        toast.error('Creating comment failed', {
          autoClose: 3000
        })
      } else {
        setComments([...comments, responseJSON])
        setNewCommentMessage('')
        fetchComments()
        if (props.commentCreateCallback) {
          props.commentCreateCallback()
        }
      }
    })
  }

  const onCommentRemove = comment => {
    if (confirm('Er du sikker på du vil slette denne kommentar?')) {
      Proxies.POST('comments/removeComment', { CommentID: comment.CommentID }).then(responseJSON => {
        if (responseJSON && responseJSON.error) {
          toast.error('Removing comment failed', {
            autoClose: 3000
          })
        } else {
          setComments([...comments.filter(c => c.CommentID !== comment.CommentID)])
          fetchComments()
        }
      })
    }
  }

  useEffect(() => {
    fetchComments()
  }, [])

  return (
    <>
      {!props.hideInput && (
        <div style={{ display: 'flex', gap: 20, alignItems: 'end', flexWrap: 'wrap' }}>
          <Input
            type='textarea'
            rows={1}
            value={newCommentMessage}
            onChange={v => setNewCommentMessage(v.target.value)}
            style={{ maxWidth: 700 }}
            onKeyDown={handleKeyPress}
          />
          <Button onClick={onCommentCreate} style={{ height: 36 }}>
            Kommentér
          </Button>
        </div>
      )}

      <div style={{ marginTop: 20 }}>
        {comments.toReversed().map(comment => (
          <div
            key={comment.CommentID}
            style={{
              borderLeft: '2px solid',
              borderLeftColor: 'grey',
              width: '100%',
              position: 'relative',
              paddingTop: 20,
              paddingLeft: 15
            }}
          >
            {/* Green circle */}
            <div style={{ width: 8, height: 8, borderRadius: 50, backgroundColor: '#28D094', position: 'absolute', left: -5, top: 28 }} />

            <div style={{ fontSize: 14, fontWeight: '600' }}>{comment.commentedBy}</div>
            <div style={{ fontSize: 14 }}>{nl2br(comment.message)}</div>
            <div style={{ fontSize: 12, opacity: 0.7, marginTop: 2, display: 'flex', gap: 10 }}>
              {moment(comment.timeInsert).format('D/M/YYYY, HH:mm')}
              {userId === comment.UserID && (
                <span style={{ cursor: 'pointer' }} onClick={() => onCommentRemove(comment)}>
                  Slet
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  )
}

export default CommentSection
